module.exports = require("./defineProperty.js");


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/helpers/define-property.js
 ** module id = 174
 ** module chunks = 0
 **/